import React,{useEffect,useContext} from 'react';
import { AppContext } from '../../store/appContext';
import "./edelmetalle.scss";
import axios from "axios";
import { useDispatchHelpers } from "../../store/dispatchhelper";
import Banner from '../../components/banner/banner';
import WebLoader from '../../components/webLoader/WebLoader';
import LiveChart from '../../components/liveChart/liveChart';
import { Fade } from 'react-awesome-reveal';
const Edelmetalle = () => {

  const {
    state: { baseUrl, edelmetalle, lang },
  } = useContext(AppContext);
  const { dispatchAction } = useDispatchHelpers();
  const isDataReady = Object.keys(edelmetalle).length > 0;

  useEffect(() => {
    axios.get(`${baseUrl}edelmetalle`).then((response) => {
      dispatchAction("setEdelmetalleData", response?.data?.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Find all span elements inside a div with class "page-container" that have style="color: white;"
    const spans = document.querySelectorAll('.page-container span[style="color: white;"]');
    // Add a class to each of these spans
    spans.forEach(span => {
      span.classList.add('white-text');
    });
     // Find all span elements that have style="color: rgb(212, 185, 123);"
     const goldSpans = document.querySelectorAll(
      ' span[style="color: rgb(212, 185, 123);"]'
    );
    // Add a class to each of these spans
    goldSpans.forEach((span) => {
      span.classList.add("gold-text");
    });
  }, [edelmetalle]);
  
  return (
    <React.Fragment>
      <WebLoader isLoading={!isDataReady} />
      <div className="edelmetalle-page page">
      {edelmetalle && isDataReady && (
        <React.Fragment>
        {<Banner mediaUrl={edelmetalle.banners[0].path} title={edelmetalle.banners[0]["title_"+lang]}/>}
        <div className="page-container" id='page-container'>
        <Fade triggerOnce={true} duration={1000} fraction={0.3}>
          <h2 className="title" dangerouslySetInnerHTML={{ __html: edelmetalle.edelmetalle[0]["title_"+lang] }} />
          <LiveChart />
        </Fade>
        <Fade direction='up' triggerOnce={true} duration={1000} fraction={0.3}>
          <p className="desc" dangerouslySetInnerHTML={{ __html: edelmetalle.edelmetalle[0]["description_"+lang] }} />
        </Fade>
        </div>

        </React.Fragment>)}
      </div>
    </React.Fragment>
  );
}

export default Edelmetalle;